// Colectivos con reserva y aforo. Pedido explicito del relevamiento del
// 2026-09-08: hoy el bus es una caja negra (recorrido fijo, nadie sabe si
// hay gente en la stop). La reserva da uso real y el aforo se monitorea from
// la torre para decidir si conviene pasar recorridos de bus a shuttles.
// Todavia sin ruta en la API (llega en R3): los schemas se publican en
// components para que mobile los conozca.
import { z } from "zod";
import { Integer, CalendarDate, Instant, RecordId, StopId, SiteId, TripId, } from "./common.js";
export const BookingId = z.string().min(1).openapi("BookingId", {
    description: "Identificador de una reserva de butaca en un colectivo.",
    example: "res_000456",
});
export const ItineraryId = z.string().min(1).openapi("ItineraryId", {
    description: "Identificador de un recorrido fijo de colectivo dentro de la planta.",
    example: "rec_centro_norte",
});
export const BookingStatus = z
    .enum(["confirmed", "cancelled", "used"])
    .openapi("BookingStatus", {
    description: "Estado de la reserva: confirmed (confirmada), cancelled (cancelada) o used (utilizada) (el pasajero abordo). La diferencia entre reservas y boardings alimenta la decision de dimensionar recorridos.",
});
export const CreateBusBookingRequest = z
    .object({
    siteId: SiteId,
    recordId: RecordId,
    itineraryId: ItineraryId,
    stopId: StopId.openapi({
        description: "Parada del recorrido donde el pasajero va a abordar.",
    }),
    date: CalendarDate.openapi({
        description: "Fecha del servicio a reservar (AAAA-MM-DD), interpretada en la zona horaria de la planta.",
    }),
})
    .openapi("CreateBusBookingRequest", {
    description: "Pedido de reserva de un lugar en un colectivo. Multi-tenant: siempre en el contexto de una planta (siteId).",
});
export const BookingResponse = z
    .object({
    bookingId: BookingId,
    siteId: SiteId,
    recordId: RecordId,
    itineraryId: ItineraryId,
    stopId: StopId,
    date: CalendarDate.openapi({
        description: "Fecha del servicio reservado (AAAA-MM-DD).",
    }),
    tripId: TripId.optional().openapi({
        description: "Viaje concreto asignado a la reserva, cuando el servicio del dia ya esta scheduled.",
    }),
    status: BookingStatus,
    createdAt: Instant.openapi({
        description: "Instant de creacion de la reserva, en ISO 8601 UTC.",
    }),
})
    .openapi("BookingResponse", {
    description: "Reserva de colectivo tal como la conoce el sistema.",
});
export const HeadcountResponse = z
    .object({
    tripId: TripId,
    siteId: SiteId,
    capacity: Integer.positive().openapi({
        description: "Butacas totales del vehiculo asignado al viaje.",
        example: 45,
    }),
    bookings: Integer.min(0).openapi({
        description: "Cantidad de reservas confirmadas para el viaje.",
        example: 32,
    }),
    boardings: Integer.min(0).openapi({
        description: "Cantidad de pasajeros que efectivamente abordaron. Contrastado con reservas, mide el uso real del recorrido.",
        example: 28,
    }),
})
    .openapi("HeadcountResponse", {
    description: "Aforo de un viaje de colectivo para monitoreo desde la torre de control. Multi-tenant: el viaje pertenece a una planta (siteId).",
});
//# sourceMappingURL=buses.js.map